<div class="relative flex h-full items-center justify-center">
  <span class="select-none font-mono text-xs text-gray-400">{{ rowIndex() + 1 }}</span>
  @if (!readonly() && canRemove()) {
    <button
      (click)="remove.emit()"
      palantirTooltip="Remover linha"
      [palantirTooltipDelay]="300"
      type="button"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white p-1 text-gray-400 opacity-0 transition-opacity hover:bg-gray-200 hover:text-red-500 group-hover:opacity-100"
    >
      <palantir-icon name="delete-outline" class="h-4 w-4"></palantir-icon>
    </button>
  }
</div>
